var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"ACADEMIC SERVICES","title":"Timetable Management","description":"Set up class timetables and assign staff responsibilities.","count-label":"timetable tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }